/**
 * Browser-side Sentry initialization
 *
 * Reads DSN and release from build-time defines (injected by build.ts).
 * Only initializes when DSN is non-empty.
 */
// Named imports only: a namespace import keeps all of @sentry/react in the
// bundle (session replay, feedback widget), even though neither is used.
import { captureException, init } from "@sentry/react";

declare const __SENTRY_DSN__: string;
declare const __SENTRY_RELEASE__: string;

export function initSentry() {
  const dsn = typeof __SENTRY_DSN__ !== "undefined" ? __SENTRY_DSN__ : "";
  const release = typeof __SENTRY_RELEASE__ !== "undefined" ? __SENTRY_RELEASE__ : "";

  if (!dsn) return;

  init({
    dsn,
    release: release || undefined,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
}

export { captureException };
